<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template>
  <!--  used to display filters in main-filters box, countries filter as well as markets filter at the top-->

  <div v-if="active" class="grey lighten-2">
    <v-layout row class="align-center">
      <v-flex class="sm10 ml-5 mt-1 pb-1">
        <v-icon medium> mdi-earth </v-icon>
        <span>
          <span class="body-2 pr-2 grey lighten-2 font-italic pa-1">
            {{
              `${combinations['markets_count']}
           `
            }}</span
          >

          <v-icon medium> mdi-dolly </v-icon>
          <span class="body-2 pr-2 grey lighten-2 font-italic pa-1">
            {{
              `${combinations['products_count']}
           `
            }}</span
          >

          <v-icon medium> mdi-sigma </v-icon>

          <span
            class="body-2 pr-2 grey lighten-2 font-italic"
            :class="{
              'green--text':
                combinations['combinations'] <=
                $store.state.user.userServerInfo.app_config.max_dsm_results,
            }"
            >{{ `${vFmt(combinations['combinations'], 0)}` }}</span
          >

          <v-icon medium> mdi-cash </v-icon>

          <span class="body-2 pr-2 grey lighten-2 font-italic pa-1">
            {{
              ` ${this.currencyString} ${this.vFmt(
                combinations['trade_value'] * this.value_convertion,
                2,
              )}`
            }}

            <v-tooltip top>
              <template v-slot:activator="{on, attrs}">
                <span
                  v-on="on"
                  @click="scroll_multiplier"
                  class="ml-1 font-weight-bold custom-button"
                >
                  {{ multiplerString }}
                </span>
              </template>
              <span> Change multiplier </span>
            </v-tooltip>

            <span>
              {{
                this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
                  .filter_in_progress
                  ? ' - Filtered'
                  : ''
              }}
            </span>
          </span>
        </span>
      </v-flex>
    </v-layout>

    <v-progress-linear
      v-if="updating"
      color="green lighten-3"
      indeterminate
      disabled="true"
    ></v-progress-linear>
    <v-progress-linear
      v-else
      color="grey lighten-4 mt-1"
      indeterminate
    ></v-progress-linear>
  </div>
</template>
<script>
  import {mapGetters, mapMutations} from 'vuex/dist/vuex.esm.browser';

  export default {
    name: 'temp-dsm-combintations',
    props: {
      combinations: Object,
      updating: Boolean,
      active: Boolean,
    },
    computed: {
      ...mapGetters(['is_run_cube_valid']),
    },
    methods: {
      ...mapMutations(['set_value_mulitplier']),
      scroll_multiplier: function () {
        this.set_value_mulitplier(
          this.display_magnitude[this.magnitude_scroller_ix]['value'],
        );
        this.magnitude_scroller_ix += 1;
        if (this.magnitude_scroller_ix === 3) {
          this.magnitude_scroller_ix = 0;
        }
      },
    },
    data() {
      return {
        magnitude_scroller_ix: 0,
        display_magnitude: [
          {text: "'000s", value: {divider: 1, prefix: "'000s", long_name: 'Thousands'}},
          {
            text: 'Millions',
            value: {divider: 1000, prefix: 'Mn', long_name: 'Millions'},
          },
          {
            text: 'Billions',
            value: {divider: 1000000, prefix: 'Bn', long_name: 'Billions'},
          },
        ],
      };
    },
  };
</script>
<style scoped>
  h3 {
    text-align: left;
    padding-top: 10px;
    margin-left: 4px;
    /*margin-bottom: 0px;*/
  }
</style>
